"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var react_copy_to_clipboard_1 = __importDefault(require("react-copy-to-clipboard"));
var QuoteReviewModal = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: store.isOpen, onClose: store.handleClose, classNames: { modal: 'coModalQuoteReviewModal-Modal' } },
        react_1.default.createElement("div", { className: "coModalQuoteReviewModal-Content" }, store.quotationCode),
        react_1.default.createElement("div", { className: "coModalQuoteReviewModal-Action" },
            react_1.default.createElement(react_copy_to_clipboard_1.default, { text: store.quotationCode, onCopy: function () { return alert('クリップボードにコピーしました'); } },
                react_1.default.createElement("button", { className: "sw-Button sw-Button-controlMain coModalQuoteReviewModal-CopyButton" }, "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3059\u308B")))));
});
exports.default = QuoteReviewModal;
